import angular from 'angular';
import employeeDropdownComponent from './employee-dropdown.component';

let employeeDropdownModule = angular.module('employeeDropdown', [])
  .component('employeeDropdown', employeeDropdownComponent);

export default employeeDropdownModule;



// WEBPACK FOOTER //
// ./client/common/directives/employee-dropdown/employee-dropdown.js